/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo } from 'react';

import StyledFooter from './Footer.style';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <StyledFooter>
      <div />
      <div>
        <a target='_blank' href="https://docs.google.com/document/d/1til6io4QzLTX6Ib1iCvYDRPNnilvrUTex2sLOwXQlSE/edit?tab=t.0" rel="noreferrer">Privacy Policy</a>
      </div>
      <span>
        &copy; {currentYear}. All rights reserved
      </span>
    </StyledFooter>
  );
};

export default memo(Footer);
